import { OMS_EXPORT_LINKED_ACCOUNT_HISTORY_PATH, OMS_INDIVIDUAL_SPEND_ACCOUNTS_PATH, OMS_SPEND_ACROSS_ACCOUNTS_PATH, } from '../../constants/paths';
import { apiBase } from '../axios-client';
export var GetIndividualSpendAccountsAPI = function (requestData) {
    return apiBase.post(OMS_INDIVIDUAL_SPEND_ACCOUNTS_PATH, requestData);
};
export var GetSpendAcrossAccountsAPI = function (requestData) {
    return apiBase.post(OMS_SPEND_ACROSS_ACCOUNTS_PATH, requestData);
};
export var ExportLinkedAccountsHistoryAPI = function (requestData) {
    return apiBase.post(OMS_EXPORT_LINKED_ACCOUNT_HISTORY_PATH, requestData);
};
